<template>
</template>

<script setup>
import { onMounted } from "vue";
// const space_src = "https://widget.usersnap.com/global/load/7eae3f3d-6919-4843-95c8-b5876b64d807?onload=onUsersnapLoad";
const project_src = "https://widget.usersnap.com/load/b0f2b4dc-839e-4006-a75d-0c605765b681?onload=onUsersnapLoad";
onMounted(() => {
  window.onUsersnapLoad = function (api) {
    api.init();
    window.UsersnapApi = api
  };
  var script = document.createElement("script");
  script.defer = 1;
  script.src = project_src;
  document.getElementsByTagName("head")[0].appendChild(script);
});
</script>

<style scoped lang="scss">
:global(us-button) {
  display: none;
}
</style>
